import React from 'react'
import Timerectificationpage from './Speciality_1'
import SpecialityescriptionSection from './Speciality_2'
import AboutSection from '../../Components/TopHeader/topheader'
export default function Speciality() {
  return (
    <div>
        <AboutSection
  title="TIME RECTIFICATION + FULL KUNDLI ANALYSIS"
  description="Unlock your true astrological blueprint with an accurate birth time correction. Receive a comprehensive Kundli reading covering career, relationships, health, and life path guidance."
/>
<div className="service-page-main-image-div">
    <img src="/assets/joinusbanner.png" alt="" className="servicepage-main-direct-image" />
</div>
<Timerectificationpage />
<SpecialityescriptionSection />

    </div>
  )
}
